export default (function () {
  $('.accordions__title').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass('accordion-active')) {
      $('.accordions__content').slideUp(400);
      $('.accordions__title').removeClass('accordion-active');
    }

    $this.toggleClass('accordion-active');
    $this.next().slideToggle();
  });
  $('.accordions-in-accordion__title').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass('accordion-active')) {
      $('.accordions-in-accordion__content').slideUp(400);
      $('.accordions-in-accordion__title').removeClass('accordion-active');
    }

    $this.toggleClass('accordion-active');
    $this.next().slideToggle();
  });
});